export default content => ({
  text: content.text
});
